import { useContext } from "react";

import { ProjectedChartContext } from "@contexts";

export const useProjectedChart = () => {
  return useContext(ProjectedChartContext);
};
